import { createAction } from 'typesafe-actions';
import { IUserSession } from '../../types/model/user';

export default class AuthActions {
    public static authSetSession = createAction('AUTH_SET_SESSION', resolve => (session ?: IUserSession | null) => resolve(session));
    public static authSetLoggedIn = createAction('AUTH_SET_LOGGED_IN', resolve => (loggedIn : boolean) => resolve(loggedIn));
    public static authSetLoggingIn = createAction('AUTH_SET_LOGGING_IN', resolve => (loggingIn : boolean) => resolve(loggingIn));
}
